import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/auth/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { BusinessSchema } from "@/components/BusinessSchema";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import VehicleDetail from "@/pages/VehicleDetail";
import Corporate from "@/pages/Corporate";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPanel from "@/pages/admin/AdminPanel";
import ResetPassword from "@/pages/ResetPassword";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#FAFBF6] text-[#404040]">
      <Navbar />
      <Outlet />
      <Footer />
      <WhatsAppButton />
      <BusinessSchema />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/filo" element={<Fleet />} />
            <Route path="/filo/:slug" element={<VehicleDetail />} />
            <Route path="/kurumsal" element={<Corporate />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/iletisim" element={<Contact />} />
          </Route>
          <Route path="/admin/giris" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
